<template>
    <div class='ba-card'>
        <div class='ba-flex ba-jc-sb ba-ai-center ba-w-100'>
            <span class='ba-title'>{{ $t("ct-integrations") }}</span>
        </div>
        <hr class='ba-hr-row'>
        <div class='ba-content ba-w-100'>
            <div class="container-accordion-form ba-grid ba-gp-1" id="accordion">
                <div v-for="(item, index) in items" :key="index" class="container-accordion-form ">
                    <div class="card ba-w-100">
                        <div class="card-header" :class="{'collapsed':!item.expanded}" :id="item.id" @click="show = item.id" data-toggle="collapse" :data-target="`#collapse-${item.id}`"
                        :aria-expanded="item.expanded" :aria-controls="`collapse-${item.id}`">
                            <span class="py-1 d-block ba-text-14 ba-montserrat-600" >{{ $t(item.name) }}
                                <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                            </span>
                        </div>
                        <div :id="`collapse-${item.id}`" :aria-labelledby="`${item.id}`" class="collapse" :class="{ 'show': item.expanded }"
                            data-parent="#accordion">
                            <div class="card-body ba-w-100">
                                <component :is="index" v-if="show == item.id"  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BrowserNotifications from '../layout/site/BrowserNotifications.vue';
import SocialProof from '../layout/site/SocialProof.vue';
// import Booking from '../layout/site/Booking.vue';

export default {
    components: {
        BrowserNotifications,
        SocialProof,
        // Booking
    },
    data() {
        return {
            items: {
                BrowserNotifications: { id: 'browser-notifications', name: 'ct-browser-notifications', expanded: true },
                SocialProof: { id: 'social-proof', name: 'ct-social-proof', expanded: false },
                // Booking: { id: 'booking', name: 'ct-booking', expanded: false },
            },
            show: 'browser-notifications'
        }
    },

}
</script>

<style lang="sass" scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/views/Integrations.vue